// MobileApp.jsx — Matrix v2 MOBILNÝ SHELL  (ústava sek. 5 + 60)
// ════════════════════════════════════════════════════════════════════
// Tmavý header · obsah · spodné taby. viewMode rozhoduje ktoré taby rola vidí.
// Mobilné moduly (Denník, Bločky, Výmery, Vozidlá, Požičovňa) sa renderujú
// v obsahu — vzor: views/_MobileModuleTemplate.jsx.
//
// Napojené v App.jsx: rola v MOBILE_ONLY_ROLES → MobileApp namiesto desktopu.
//
// STAVBA_HISTORIA_V1 (Mirko 21. 10. 2026, ksbx-appky 2677: „Áno, jedna appka MATRIX Stavba podľa role podľa návrhu 2675, zadaj to aj s Históriou 2669.“;
// 2690: „časom sa rozšíri o niečo z matrixu“): LIŠTA PODĽA ROLE ZO SERVERA (GET /api/mobile/modules → lista, dalsie) — mview = zrkadlo appky.
//   parťák partie a hodinovkár (rola partak — ústava 3: v partii omietok, malieb a poterov sa prihlasuje len parťák, hodinovkár každý):
//   Dnes · Denník/Pokládka · História · Ja · majster: to isté + Moje zákazky · vedenie (admin, owner, office, účtovníčka):
//   Prehľad · Stavby · História · Ja. Časti, ktoré rola mala v mview doteraz (Tabuľa dňa, Denník, Bločky, Závady, Obhliadka, Používatelia),
//   sú v Ja → Ďalšie časti Matrixu — nič nezmizlo. Šofér, servis a skener majú lištu ako doteraz.

import React, { useState, useEffect } from 'react'
import { useAuth } from '../auth/AuthContext.jsx'
import { DochadzkaBanner } from './DochadzkaAlarm.jsx'   // 12. 9. 2026 pás dochádzky hodinovkárov (bliká + pípa + vibruje)
import { useT } from '../i18n.js'
import { COLORS, TYPO, SPACE, RADIUS } from '../theme.js'
import { ToastProvider } from './Toast.jsx'
import DennikMobile from '../views/DennikMobile.jsx'
import PozicovnaMobile from '../views/PozicovnaMobile.jsx'
import BlockyMobile from '../views/BlockyMobile.jsx'
import DochadzkaMobile from './DochadzkaMobile.jsx'
import VymeryMobile from '../views/VymeryMobile.jsx'
import UsersMobile from '../views/UsersMobile.jsx'
import ObhliadkaMobile from '../views/ObhliadkaMobile.jsx'
import ZavadyMobile from '../views/ZavadyMobile.jsx'
import DenTabulaMobile from '../views/DenTabulaMobile.jsx'   // mojden_v3: spoločná tabuľa dňa aj na mobile (Mirko 29. 9. 2026: body pre office AJ technika)
import PokladkaMobile from '../views/PokladkaMobile.jsx'     // mview_appka_v1 (17. 10. 2026): pokládka po celých bytoch pre partiu poterov (Mirko 1506/1516)
import JaMobile from '../views/JaMobile.jsx'                 // mview_appka_v1: obrazovka Ja (mockup 1508)
import HistoriaMobile from '../views/HistoriaMobile.jsx'     // STAVBA_HISTORIA_V1: História dokladov (2669)
import PrehladMobile from '../views/PrehladMobile.jsx'       // STAVBA_HISTORIA_V1: Prehľad pre vedenie (2675, screenshoty 1.3 (13))
import StavbyMobile from '../views/StavbyMobile.jsx'         // STAVBA_HISTORIA_V1: Stavby pre vedenie, Moje zákazky pre majstra
import AnhydritMobile from '../views/AnhydritMobile.jsx'     // STAVBA_HISTORIA_V1: Pokračovať v rozrobenom protokole z Histórie, Prehľadu, Stavieb a Dnes
import NavIcon from './NavIcon.jsx'
import { M as MOCK } from '../views/mockupTheme.js'   // mview_appka_v2: vzhľad robotníka = mockup v5 (Mirko 1585)
import { fetchAuth } from '../auth/fetchAuth.js'   // dochadzka_v1

// viewMode → povolené taby (ústava sek. 5) — STAVBA_HISTORIA_V1: platí len pre šoféra, servis a skener; ostatným dáva lištu server (záloha nižšie)
const VIEW_MODE_TABS = {
  admin:     ['den', 'dennik', 'blocky', 'zavady', 'obhliadka'],      // + bonus 'asistent' + 'uzivatelia' pridáva sa nižšie
  foreman:   ['den', 'dennik', 'dochadzka', 'zavady', 'obhliadka'],   // foreman (Majster) — Výmery + Dochádzka; 'den' = tabuľa dňa (mojden_v3)
  partak:    ['dennik', 'dochadzka'],             // parťák/hodinovkár: Denník + Dochádzka (Mirko 5.8.: 'zápis môže k dochádzke a fotky robí každý'); ústava 121 — kto nie je hodinovkár, toho odmietne API
  craftsman: ['dochadzka', 'blocky'],             // omietkar/poterar/maliar — denník NEMAJÚ, ale dochádzku ÁNO
  driver:    ['den', 'vozidla', 'blocky'],          // šofér vidí, kam ho dnes treba (mojden_v3)
  service:   ['den', 'pozicovna', 'vozidla', 'blocky'],  // Marek — ústava 58.8 plný prístup
  scanner:   ['blocky'],
  none:      [],
}
function getViewMode(role) {
  if (['admin', 'owner', 'owner_view', 'accountant', 'office_manager'].includes(role)) return 'vedenie'   // STAVBA_HISTORIA_V1: vedenie vrátane office (2677)
  if (role === 'foreman') return 'majster'
  if (role === 'partak') return 'partak'
  if (['omietkar', 'poterar', 'maliar'].includes(role)) return 'craftsman'
  if (role === 'service') return 'service'
  if (role === 'driver') return 'driver'
  return 'scanner'
}
// záloha lišty, kým neodpovie server (alebo bez signálu) — tie isté zoznamy ako stavba_mobil_api LISTY; posledná zo servera sa pamätá
const LISTA_ZALOHA = {
  vedenie:   { lista: ['prehlad', 'stavby', 'historia', 'ja'], dalsie: ['den', 'dennik', 'blocky', 'zavady', 'obhliadka'] },
  majster:   { lista: ['dochadzka', 'dennik', 'zakazky', 'historia', 'ja'], dalsie: ['den', 'zavady', 'obhliadka'] },
  partak:    { lista: ['dochadzka', 'dennik', 'historia', 'ja'], dalsie: [] },
}   // remeselník (craftsman) do Matrixu nechodí (ústava 3) — ak ho Mirko zapne, lišta ako doteraz

const TAB_META = {
  dennik:    { icon: '', labelKey: 'mobile.tab.dennik' },
  blocky:    { icon: '', labelKey: 'mobile.tab.blocky' },
  vymery:    { icon: '', labelKey: 'mobile.tab.vymery' },
  vozidla:   { icon: '', labelKey: 'mobile.tab.vozidla' },
  pozicovna: { icon: '', labelKey: 'mobile.tab.pozicovna' },
  dochadzka: { icon: '', labelKey: 'mobile.tab.dochadzka' },
  uzivatelia:{ icon: '', labelKey: 'mobile.tab.uzivatelia' },
  obhliadka: { icon: '', labelKey: 'Obhliadka' },
  zavady:    { icon: <NavIcon name='zavady' size={22} />, labelKey: 'Závady' },
  den:       { icon: '', labelKey: 'Dnes' },
  pokladka:  { icon: '', labelKey: 'mobile.tab.pokladka' },   // mview_appka_v1
  ja:        { icon: '', labelKey: 'mobile.tab.ja' },         // mview_appka_v1
  prehlad:   { icon: '', labelKey: 'Prehľad' },               // STAVBA_HISTORIA_V1
  stavby:    { icon: '', labelKey: 'Stavby' },
  zakazky:   { icon: '', labelKey: 'Moje zákazky' },
  historia:  { icon: '', labelKey: 'História' },
}
const _pamL = (k, v) => { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)) } catch (_) { return null } }

export function MobileApp() {
  const { user, logout } = useAuth()
  const t = useT()
  const viewMode = getViewMode(user && user.role)
  const vedenie = viewMode === 'vedenie', majster = viewMode === 'majster'

  // dochadzka_v1 (Mirko 25. 9. 2026, ústava 121.15): tab Dochádzka podľa POĽA na karte zamestnanca (employees.attendance_required), nie podľa roly
  // noc_v2 (simulácia 1804: 'bez signálu Príchod zmizne'): čo telefón naposledy vedel, drží si v pamäti — dnes, pre toho istého človeka
  const _pam = (k, v) => { try { if (v === undefined) return JSON.parse(localStorage.getItem('kamir_m_' + k) || 'null'); localStorage.setItem('kamir_m_' + k, JSON.stringify(v)) } catch (_) { return null } }
  const _dnes = new Date().toISOString().slice(0, 10)
  const [maDoch, setMaDoch] = useState(null)
  useEffect(() => {
    let alive = true
    fetchAuth('/api/hodinovkari/dnes').then(r => (r && r.ok) ? r.json() : null).then(x => { const v = !!(x && x.me && x.me.hourly); if (x) _pam('madoch', v); if (alive) setMaDoch(v) }).catch(() => { if (alive) setMaDoch(_pam('madoch') === true) })
    return () => { alive = false }
  }, [])
  // ── mview_appka_v1 (Mirko 17. 10. 2026, Kronika 1516: mview kopíruje schválený mockup appky; 1426: denník sa odomyká
  //    príchodom; 1506: pokládka po celom byte). Robotník (partak/craftsman) má: Dnes · Denník ALEBO Pokládka · ostatné.
  //    Zámok drží server (423 „Najprv Príchod“), tu sa len zrkadlí. Pokládka sa ukáže, keď má zákazka dňa poterové výmery
  //    (register Výmery, 0.J) — inak Denník ako doteraz.
  const [me, setMe] = useState(null)             // /api/mobile/modules → employee_id, lista (STAVBA_HISTORIA_V1)
  const [den, setDen] = useState(null)           // /api/dochadzka/dnes/:emp → { otvoreny, rows }
  const [poterByty, setPoterByty] = useState(false)
  const [mojaPrva, setMojaPrva] = useState(null)   // prvá zákazka z Rozpisu — Pokládka sa ukáže už pred príchodom
  const nacitajDen = React.useCallback(async () => {
    try {
      let emp = me && me.employee_id
      if (!emp) { const m = await fetchAuth('/api/mobile/modules').then(r => (r && r.ok) ? r.json() : null); if (m) { setMe(m); emp = m.employee_id; if (Array.isArray(m.lista)) _pamL('kamir_m_lista', { role: m.role, lista: m.lista, dalsie: m.dalsie || [] }) } }
      if (!emp) { setDen({ rows: [], otvoreny: null }); return }
      const d = await fetchAuth('/api/dochadzka/dnes/' + encodeURIComponent(emp)).then(r => (r && r.ok) ? r.json() : null)
      setDen(d || { rows: [], otvoreny: null })
      let mp0 = mojaPrva
      if (!mojaPrva) { const mp = await fetchAuth('/api/dochadzka/projekty?moje=1').then(r => (r && r.ok) ? r.json() : []).catch(() => []); if (Array.isArray(mp) && mp.length) { setMojaPrva(mp[0]); mp0 = mp[0] } }
      if (d) _pam('den', { datum: _dnes, emp: String(emp), den: d, mojaPrva: mp0 || null })
    } catch (_) {
      const c = _pam('den')   // noc_v2: bez signálu — dnešný stav z telefónu (Príchod, zákazka dňa)
      if (c && c.datum === _dnes) { setDen(d => d || c.den); if (!mojaPrva && c.mojaPrva) setMojaPrva(c.mojaPrva) }
      else setDen(d => d || { rows: [], otvoreny: null })
    }
  }, [me, mojaPrva])
  useEffect(() => { nacitajDen() }, [])   // eslint-disable-line react-hooks/exhaustive-deps
  const robotnik = viewMode === 'partak' || viewMode === 'craftsman'
  const naStavbe = robotnik || majster || vedenie   // STAVBA_HISTORIA_V1: Pokládka podľa zákazky dňa aj pre majstra a v Mojom dni vedenia
  const _rows = (den && den.rows) || []
  const zakazkaDna = (den && den.otvoreny && den.otvoreny.project_id) || (_rows.length ? _rows[_rows.length - 1].project_id : '') || (mojaPrva && mojaPrva.id) || ''
  const zakazkaDnaNazov = (den && den.otvoreny && den.otvoreny.project_name) || (_rows.length ? _rows[_rows.length - 1].project_name : '') || (mojaPrva && ((mojaPrva.zakazka_code || mojaPrva.id) + ' · ' + (mojaPrva.name || ''))) || ''
  useEffect(() => {
    let alive = true
    if (!naStavbe || !zakazkaDna) { setPoterByty(false); return }
    fetchAuth('/api/vymery-stav/' + encodeURIComponent(zakazkaDna) + '?remeslo=potery').then(r => (r && r.ok) ? r.json() : null)
      .then(d => { const v = (d && Array.isArray(d.byty) && d.byty.length) ? true : ((d && (d.typ_zakazky === 'potery' || d.pokladka_robi === 'ina_firma')) ? 'celok' : false); if (d) _pam('poter_' + zakazkaDna, v); if (alive) setPoterByty(v) }).catch(() => { const z = _pam('poter_' + zakazkaDna); if (alive) setPoterByty(z === true || z === 'celok' ? z : false) })   // CELOK_DIELA_V1: poterová zákazka bez Výmer = celok diela
    return () => { alive = false }
  }, [zakazkaDna, naStavbe])
  const prichodDnes = !!(den && (den.otvoreny || _rows.length))
  const zamokDennika = robotnik && maDoch === true && den !== null && !prichodDnes

  // ── STAVBA_HISTORIA_V1: lišta zo servera; záloha = posledná zo servera, inak zoznam podľa roly ──
  const _L = (me && Array.isArray(me.lista)) ? { lista: me.lista.map(x => x.id), dalsie: (me.dalsie || []).map(x => x.id) }
    : (() => { const c = _pamL('kamir_m_lista'); if (c && c.role === (user && user.role) && Array.isArray(c.lista)) return { lista: c.lista.map(x => x.id), dalsie: (c.dalsie || []).map(x => x.id) }; return LISTA_ZALOHA[viewMode] || null })()
  const dalsie = (_L && _L.dalsie) ? _L.dalsie.concat(user?.role === 'admin' && !_L.dalsie.includes('uzivatelia') ? ['uzivatelia'] : []) : []
  const baseTabs = (_L && _L.lista) || VIEW_MODE_TABS[viewMode] || ['blocky']
  const tabKeys0 = (maDoch === true && !vedenie)   // STAVBA_HISTORIA_V1: vedenie má Dnes v karte Môj deň (screenshoty 1.3 (13)), nie v lište
    ? (baseTabs.includes('dochadzka') ? baseTabs : ['dochadzka', ...baseTabs])
    : baseTabs.filter(k => k !== 'dochadzka')
  // Pokládka pri poterovej zákazke dňa (denník pokládky vzniká z odškrtania sám — Mirko 1442).
  // DENNIK_TUK_V1 (mockup v2 2864: „typ zákazky už nerozhoduje — rozhoduje človek a jeho deň“): Denník ostáva vedľa Pokládky —
  // kto na poterovej stavbe robí niečo iné (prípravné práce, upratovanie, prestoj s fotkou), zapíše to v Denníku na ťuk.
  const stavbaLista = robotnik || majster
  const tabKeys1 = (stavbaLista && poterByty === true)
    ? (tabKeys0.includes('dennik') ? tabKeys0.flatMap(k => k === 'dennik' ? ['pokladka', 'dennik'] : [k]) : [tabKeys0[0], 'pokladka', ...tabKeys0.slice(1)].filter(Boolean))
    : (stavbaLista && poterByty === 'celok')   // CELOK_DIELA_V1: bez Výmer sa denník z odškrtania nerobí — Denník ostáva, Pokládka (anhydrit celok diela) pribudne
      ? (tabKeys0.includes('dennik') ? tabKeys0.flatMap(k => k === 'dennik' ? ['pokladka', 'dennik'] : [k]) : [tabKeys0[0], 'pokladka', ...tabKeys0.slice(1)].filter(Boolean))
      : tabKeys0
  // mockup: robotník má Dnes · Denník/Pokládka · … · Ja — Dnes (príchod) je prvý krok dňa (Mirko 1426)
  const tabKeys = (robotnik && !_L)
    ? [...(tabKeys1.includes('dochadzka') ? ['dochadzka'] : []), ...tabKeys1.filter(k => k !== 'dochadzka'), 'ja']
    : tabKeys1
  // Admin BONUS (sek. 64.2): pri starej lište šoféra/servisu/skenera nie — Používatelia má admin v Ja → Ďalšie časti (STAVBA_HISTORIA_V1)
  const finalTabKeys = tabKeys
  const novyVzhlad = !!_L   // STAVBA_HISTORIA_V1: vedenie, majster aj robotník majú lištu a vzhľad appky (mockup v5)
  // Default tab: prvý z lišty; persist v localStorage — pamätá posledný tab medzi sessions
  const STORAGE_KEY = 'kamir_v2_mobile_active_tab'
  // Hlasový asistent NEO vypnutý 12. 9. 2026 (Mirko: „vypnúť a vymazať aj z mobil view“) — asistent = Trinity (Anton), ústava 102
  const defaultTab = tabKeys[0]
  try { if (localStorage.getItem('kamir_v2_mobile_active_tab') === 'asistent') localStorage.removeItem('kamir_v2_mobile_active_tab') } catch {}
  const [active, setActive] = useState(() => {
    const saved = (() => { try { return localStorage.getItem(STORAGE_KEY) } catch { return null } })()
    return (saved && finalTabKeys.includes(saved)) ? saved : defaultTab
  })
  // STAVBA_HISTORIA_V1: podstránka nad obsahom — rozrobený protokol, karta stavby, Môj deň, Pokládka/Denník Môjho dňa, časť z Ja
  const [pod, setPod] = useState(null)
  const [obnov, setObnov] = useState(0)
  const setActiveAndPersist = (key) => {
    if (key === active) setObnov(n => n + 1)   // ťuk na aktívnu záložku = späť na jej začiatok (zoznam), ako v appke
    setActive(key); setPod(null)
    try { localStorage.setItem(STORAGE_KEY, key) } catch {}
  }
  useEffect(() => { if (maDoch === false && active === 'dochadzka' && tabKeys[0]) setActiveAndPersist(tabKeys[0]) }, [maDoch])
  // mview_appka_v1: aktívny tab musí byť v zozname (Denník sa pri poteroch mení na Pokládku); robotník bez dnešného
  // príchodu začína na Dnes — príchod je prvý krok dňa (Mirko 1426). Raz po načítaní dňa, potom rozhoduje človek.
  const _prvyRaz = React.useRef(false)
  useEffect(() => {
    if (!finalTabKeys.length) return
    if (robotnik && maDoch === true && den !== null && !_prvyRaz.current) { _prvyRaz.current = true; if (!prichodDnes && finalTabKeys.includes('dochadzka')) { setActiveAndPersist('dochadzka'); return } }
    if (!finalTabKeys.includes(active)) setActiveAndPersist(finalTabKeys[0])
  }, [finalTabKeys.join('|'), den !== null, maDoch])   // eslint-disable-line react-hooks/exhaustive-deps   // dochadzka_v1: tab zmizol → prejdi na prvý

  const mainRef = React.useRef(null)
  useEffect(() => { if (mainRef.current) mainRef.current.scrollTop = 0 }, [active, pod])   // nová záložka alebo podstránka sa otvorí od začiatku
  const otvorProtokol = x => { if (!x || !x.mozem_pokracovat) return; setPod({ typ: 'protokol', x }) }   // PROTOKOL_CEMENT_MVIEW_V1: cementový sa neotvorí ako anhydrit
  const zavri = () => { setPod(null); setObnov(n => n + 1) }
  const Spat = ({ text, onClick }) => <div style={{ padding: '10px 16px 0', background: MOCK.bg }}><button type="button" onClick={onClick} style={{ background: 'none', border: 'none', color: MOCK.ac, fontSize: 17, fontWeight: 600, minHeight: 44, cursor: 'pointer', fontFamily: 'inherit', padding: 0 }}>‹ {text}</button></div>
  const modul = (id) => id === 'den' ? <DenTabulaMobile /> : id === 'dennik' ? <DennikMobile /> : id === 'blocky' ? <BlockyMobile /> : id === 'zavady' ? <ZavadyMobile />
    : id === 'obhliadka' ? <ObhliadkaMobile /> : id === 'uzivatelia' ? <UsersMobile /> : <TabPlaceholder tabKey={id} t={t} />
  const podstranka = () => {
    if (!pod) return null
    if (pod.typ === 'protokol') { const x = pod.x
      return <AnhydritMobile key={x.id} projectId={x.project_id} projectName={x.nazov_stavby || x.project_name} obj={x.obj || ''} poschodia={[x.po]} celok={!!x.celok} plochaZakazky={x.plocha_zakazky || 0} spatText="Späť" onSpat={zavri} /> }
    if (pod.typ === 'stavba') return <StavbyMobile startPid={pod.pid} onZavriet={zavri} onOtvorProtokol={otvorProtokol} />
    if (pod.typ === 'mojden') return <><Spat text="Prehľad" onClick={zavri} /><DochadzkaMobile me={me} onZmena={nacitajDen} onOtvorDennik={() => setPod({ typ: poterByty ? 'pokladka' : 'dennik_md' })} /></>
    if (pod.typ === 'pokladka') return <PokladkaMobile projectId={zakazkaDna} projectName={zakazkaDnaNazov} onSpat={() => setPod({ typ: 'mojden' })} />
    if (pod.typ === 'dennik_md') return <><Spat text="Môj deň" onClick={() => setPod({ typ: 'mojden' })} /><DennikMobile /></>
    if (pod.typ === 'modul') return <><Spat text="Ja" onClick={zavri} />{modul(pod.id)}</>
    return null
  }
  // STAVBA_HISTORIA_V1 (2667: „zoznam Rozpracované protokoly na zákazke aj na Dnes“): rozrobený protokol môj a mojej partie → Pokračovať
  const [rozrob, setRozrob] = useState([])
  useEffect(() => {
    if (!stavbaLista || active !== 'dochadzka' || pod) return
    let alive = true
    fetchAuth('/api/mobile/historia?rozsah=partia&stav=rozrobene&limit=1').then(r => (r && r.ok) ? r.json() : null)
      .then(j => { if (alive && j) setRozrob((j.rozrobene || []).flatMap(g => g.polozky).filter(x => x.mozem_pokracovat)) }).catch(() => {})
    return () => { alive = false }
  }, [active, pod, obnov, stavbaLista])

  return (
    <ToastProvider>
      <div style={{
        height: '100vh',          // FIXED výška — main overflow funguje, spodná lišta drží (Mirko 2026-05-25)
        display: 'flex', flexDirection: 'column',
        background: novyVzhlad ? MOCK.bg : COLORS.bgSoft, color: novyVzhlad ? MOCK.txt : COLORS.text,
        fontFamily: novyVzhlad ? MOCK.font : TYPO.family, fontSize: novyVzhlad ? 16 : TYPO.sizes.base,
        maxWidth: 640, margin: '0 auto',
        position: 'relative', overflow: 'hidden',
      }}>
        {/* ── tmavý header (ústava 25.5); lišta appky ho nemá — Odhlásiť a Desktop sú v Ja, mockup v5 (mview_appka_v2, STAVBA_HISTORIA_V1) ── */}
        {!novyVzhlad && <header style={{
          background: COLORS.base, color: '#fff',
          display: 'flex', alignItems: 'center', gap: SPACE.sm,
          padding: `calc(${SPACE.sm}px + env(safe-area-inset-top)) ${SPACE.md}px ${SPACE.sm}px`,
          flexShrink: 0,
        }}>
          <span style={{
            fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra, letterSpacing: '-0.02em',
          }}>Matrix</span>
          <span style={{ flex: 1 }} />
          <span style={{ fontSize: TYPO.sizes.sm, opacity: 0.85 }}>
            {(user && (user.cele_meno || user.display_name || user.username)) || ''}
          </span>
          <button onClick={logout} style={{
            background: 'rgba(255,255,255,0.14)', color: '#fff', border: 'none',
            borderRadius: RADIUS.md, padding: '7px 14px', fontSize: TYPO.sizes.sm,
            fontFamily: 'inherit', cursor: 'pointer', minHeight: 36,
          }}>{t('mobile.logout')}</button>
        </header>}

        {/* mview_appka_v1: key = stav dňa → po príchode/odchode sa pás načíta hneď (inak by 60 s ešte hlásil „chýba“ a pípal) */}
        <DochadzkaBanner key={'dch-' + _rows.length + '-' + ((den && den.otvoreny && den.otvoreny.id) || '')} onOpen={() => vedenie ? setPod({ typ: 'mojden' }) : setActiveAndPersist('dochadzka')} />
        {/* ── obsah ── */}
        <main ref={mainRef} style={{ flex: 1, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
          {pod ? podstranka()
            : active === 'prehlad' ? <PrehladMobile key={obnov} onMojDen={() => setPod({ typ: 'mojden' })} onOtvorProtokol={otvorProtokol} onOtvorStavbu={pid => setPod({ typ: 'stavba', pid })} />
            : active === 'stavby' || active === 'zakazky' ? <StavbyMobile key={active + obnov} majster={active === 'zakazky'} onOtvorProtokol={otvorProtokol} />
            : active === 'historia' ? <HistoriaMobile key={obnov} vedenie={vedenie} onPokracovat={otvorProtokol} />
            : active === 'den' ? <DenTabulaMobile />
            : active === 'dochadzka' ? <>
                {/* STAVBA_HISTORIA_V1: rozrobený protokol → Pokračovať (zo servera — aj z iného telefónu, aj po vybitom telefóne) */}
                {rozrob.length > 0 && <div style={{ padding: '12px 16px 0', background: MOCK.bg, fontFamily: MOCK.font }}>{rozrob.slice(0, 3).map(x => (
                  <div key={x.id} role="button" onClick={() => otvorProtokol(x)} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 14, padding: '10px 14px', marginBottom: 8, cursor: 'pointer' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 15, fontWeight: 700, color: MOCK.txt }}>Rozrobený protokol anhydritu</div>
                      <div style={{ fontSize: 13, color: MOCK.mut }}>{x.nazov_stavby} · {x.id} · {x.miesto} · {x.stav_text}</div>
                    </div>
                    <span style={{ color: MOCK.ac, fontWeight: 700, fontSize: 15 }}>Pokračovať ›</span>
                  </div>))}</div>}
                <DochadzkaMobile me={me} onZmena={nacitajDen} onOtvorDennik={stavbaLista ? () => setActiveAndPersist(poterByty ? 'pokladka' : 'dennik') : null} />
              </>
            : active === 'dennik' ? (zamokDennika ? <ZamokPrichod t={t} onPrichod={() => setActiveAndPersist('dochadzka')} /> : <DennikMobile />)
            : active === 'ja' ? <JaMobile user={user} me={me} onLogout={logout} dalsie={vedenie || majster ? dalsie.map(id => ({ id, nazov: (me && (me.dalsie || []).find(x => x.id === id) || {}).nazov || t((TAB_META[id] || {}).labelKey || id) })) : []} onOtvor={id => setPod({ typ: 'modul', id })} naDesktop={user?.role === 'admin'} />
            : active === 'pokladka' ? (zamokDennika ? <ZamokPrichod t={t} onPrichod={() => setActiveAndPersist('dochadzka')} /> : <PokladkaMobile projectId={zakazkaDna} projectName={zakazkaDnaNazov} onSpat={() => setActiveAndPersist('dochadzka')} />)
            : active === 'pozicovna' ? <PozicovnaMobile />
            : active === 'blocky' ? <BlockyMobile />
            : active === 'vymery' ? (
                /* VÝMERY = funkčný prvý-v2-model cez iframe VYMERY_TEST.html (Mirko 2026-06-01:
                   React VymeryMobile mal zadávanie meraní len ako placeholder „pripravuje sa").
                   Token sa berie z localStorage('kamir_token'), same-origin /uploads/, offline-first. */
                <div style={{ padding: 24, fontSize: 15, lineHeight: 1.5, color: '#475569' }}>Mobilné výmery sú dočasne vypnuté. Výmery zadávaj na počítači alebo v OMERAJ. Pripravíme ich do iOS aplikácie.</div>
                /* vypnuté 14. 9. 2026 (Mirko) — pôvodne iframe /uploads/VYMERY_TEST.html */ || <iframe title="Výmery"
                  style={{ width: '100%', height: '100%', minHeight: 'calc(100vh - 150px)', border: 'none', display: 'block' }} />
              )
            : active === 'obhliadka' ? <ObhliadkaMobile />
            : active === 'zavady' ? <ZavadyMobile />
            : active === 'uzivatelia' ? <UsersMobile />
            : <TabPlaceholder tabKey={active} t={t} />}
        </main>

        {/* ── spodné taby (MOZOG sek. 60 — veľké plochy) ── */}
        {/* LISTA_2RADY — Mirko 13. 9. 2026: „strašne slabé zobrazenie, dole sa nedá trafiť, čo chcem prepnúť“ → veľké, rovnako široké
            tlačidlá s väčším písmom; pri viac ako 4 taboch dva rady (mriežka), aktívny tab je plný, kontrastný. Ikony len ak existujú. */}
        {novyVzhlad ? (
          /* mview_appka_v2: lišta ako v appke (mockup v5) — ikona + popis, biela, aktívny modrý; STAVBA_HISTORIA_V1: aj vedenie a majster */
          <nav style={{ display: 'flex', flexShrink: 0, justifyContent: 'space-around', alignItems: 'flex-start', padding: '8px 6px',
            paddingBottom: 'calc(8px + env(safe-area-inset-bottom))', background: 'rgba(255,255,255,0.96)', borderTop: `1px solid ${MOCK.line}`, fontFamily: MOCK.font }}>
            {finalTabKeys.map(key => {
              const on = key === active && !pod
              const ikona = key === 'dochadzka' ? 'hodiny' : key === 'ja' ? 'osoba' : key === 'pokladka' ? 'mriezka' : key === 'prehlad' ? 'prehlad' : (key === 'stavby' || key === 'zakazky') ? 'budova' : key === 'historia' ? 'historia' : 'dokument'
              const popis = key === 'dochadzka' ? t('mobile.tab.dnes') : ((me && (me.lista || []).find(x => x.id === key)) || {}).nazov || t((TAB_META[key] || TAB_META.blocky).labelKey)
              const zamok = zamokDennika && (key === 'dennik' || key === 'pokladka')
              return (
                <button key={key} onClick={() => setActiveAndPersist(key)} style={{ border: 'none', background: 'none', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3,
                  fontSize: 11, fontWeight: 600, color: on ? MOCK.ac : MOCK.mut, cursor: 'pointer', minWidth: 64, minHeight: 50, fontFamily: 'inherit', position: 'relative' }}>
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    {ikona === 'hodiny' && <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>}
                    {ikona === 'osoba' && <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>}
                    {ikona === 'mriezka' && <><rect x="3" y="3" width="8" height="8" rx="2" /><rect x="13" y="3" width="8" height="8" rx="2" /><rect x="3" y="13" width="8" height="8" rx="2" /><rect x="13" y="13" width="8" height="8" rx="2" /></>}
                    {ikona === 'dokument' && <><path d="M4 4h12l4 4v12H4z" /><path d="M8 12h8M8 16h5" /></>}
                    {ikona === 'prehlad' && <><rect x="3" y="4" width="18" height="7" rx="2" /><rect x="3" y="13" width="18" height="7" rx="2" /></>}
                    {ikona === 'budova' && <><path d="M4 21V4h10v17" /><path d="M14 9h6v12" /><path d="M7 8h1M10 8h1M7 12h1M10 12h1M7 16h1M10 16h1M17 13h1M17 17h1" /><path d="M2 21h20" /></>}
                    {ikona === 'historia' && <><path d="M3 12a9 9 0 1 0 3-6.7" /><path d="M3 4v5h5" /><path d="M12 8v4l3 2" /></>}
                  </svg>
                  <span>{popis}{zamok ? ' · zámok' : ''}</span>
                </button>
              )
            })}
          </nav>
        ) : (
        <nav style={{
          display: 'grid', flexShrink: 0, gap: 6, padding: '6px 6px',
          gridTemplateColumns: `repeat(${finalTabKeys.length > 4 ? Math.ceil(finalTabKeys.length / 2) : finalTabKeys.length}, 1fr)`,
          background: COLORS.bg, borderTop: `1px solid ${COLORS.line}`,
          paddingBottom: 'calc(6px + env(safe-area-inset-bottom))',
        }}>
          {finalTabKeys.map(key => {
            const meta = TAB_META[key] || TAB_META.blocky
            const on = key === active
            return (
              <button key={key} onClick={() => setActiveAndPersist(key)} style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                minHeight: 52, padding: '6px 4px', borderRadius: 12,
                background: on ? COLORS.nav : COLORS.bgSoft, border: `1px solid ${on ? COLORS.nav : COLORS.line}`,
                color: on ? '#fff' : COLORS.text, cursor: 'pointer', fontFamily: 'inherit',
                fontSize: 14, fontWeight: 700, lineHeight: 1.1, textAlign: 'center', whiteSpace: 'normal',
              }}>
                {meta.icon ? <span style={{ display: 'inline-flex', fontSize: 16 }}>{meta.icon}</span> : null}
                <span>{key === 'dochadzka' && robotnik ? t('mobile.tab.dnes') : t(meta.labelKey)}{zamokDennika && (key === 'dennik' || key === 'pokladka') ? ' · zámok' : ''}</span>
              </button>
            )
          })}
        </nav>
        )}
      </div>
    </ToastProvider>
  )
}

// Placeholder — kým modul nie je migrovaný do V2 (krok 2+)
function TabPlaceholder({ tabKey, t }) {
  const meta = TAB_META[tabKey] || TAB_META.blocky
  return (
    <div style={{
      padding: SPACE.xxl, textAlign: 'center', color: COLORS.muted,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      minHeight: '60vh',
    }}>
      <div style={{ fontSize: 56, marginBottom: SPACE.md }}>{meta.icon}</div>
      <div style={{ fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.bold, color: COLORS.text }}>
        {t(meta.labelKey)}
      </div>
      <div style={{ marginTop: SPACE.sm, fontSize: TYPO.sizes.base }}>
        {t('mobile.module_soon')}
      </div>
    </div>
  )
}

// mview_appka_v1 — zámok Denníka/Pokládky do príchodu (Mirko 1426). Server to stráži 423, tu je to len zrkadlo.
function ZamokPrichod({ t, onPrichod }) {
  return (
    <div style={{ padding: 32, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: 10, background: MOCK.bg, fontFamily: MOCK.font }}>
      <div style={{ color: '#c5ccd6' }}><NavIcon name="lock" size={72} /></div>
      <div style={{ fontSize: 22, fontWeight: 700, color: MOCK.txt }}>{t('mobile.zamok.nadpis')}</div>
      <div style={{ fontSize: 14, color: MOCK.mut, maxWidth: 320 }}>{t('mobile.zamok.text')}</div>
      <button type="button" onClick={onPrichod} style={{ marginTop: 10, width: '100%', maxWidth: 360, minHeight: 72, border: 'none', borderRadius: 16, background: MOCK.grn, color: '#fff', fontSize: 20, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit' }}>{t('mobile.zamok.tlacidlo')}</button>
    </div>
  )
}

export default MobileApp
